/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr, hasMany } from '@ember-data/model';

export default class MailerSection extends Model {
  // Relationships
  @hasMany('mailer-template-section') mailerTemplateSection;
  @hasMany('mailer-section-block') mailerSectionBlocks;
  // Attributes
  @attr('immutable', { defaultValue: () => ({}) }) settings;
  @attr('string') title;
  @attr('boolean') sortable;
  @attr('boolean') editable;
}
